import { Decoration_Type } from "./../ricos-types";
import { RESOLVERS_IDS } from "./../toolbars-v3/lib/resolvers-ids";
import { TEXT_BUTTON_SPOILER } from "./data-hooks";
import SpoilerTextButtonIcon from "./icons/SpoilerTextButtonIcon";
const getTextButtons = () => {
  return [
    {
      id: Decoration_Type.SPOILER,
      type: "toggle",
      presentation: {
        dataHook: TEXT_BUTTON_SPOILER,
        tooltip: "Spoiler_Insert_Tooltip",
        icon: SpoilerTextButtonIcon
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        active: RESOLVERS_IDS.IS_TEXT_CONTAINS_SPOILER,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED
      },
      command: ({ publicCommands }) => () => {
        publicCommands.toggleInlineStyle("spoiler");
        return true;
      }
    }
  ];
};
export {
  getTextButtons
};
//# sourceMappingURL=getTextButtons.js.map
